import { render } from "./AddBirth.vue?vue&type=template&id=00591038&scoped=true"
import script from "./AddBirth.vue?vue&type=script&lang=js"
export * from "./AddBirth.vue?vue&type=script&lang=js"

import "./AddBirth.vue?vue&type=style&index=0&id=00591038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00591038"]])

export default __exports__